import request from "@/axios/request";
const envApi = "https://saas.iotreallinks.com/prod";

// 登录方法
export function login(username, password, code, uuid, sourceType) {
  const data = {
    username,
    password,
    code,
    uuid,
    sourceType,
  };
  return request({
    url: `${envApi}/login`,
    headers: {
      isToken: false,
    },
    method: "post",
    data: data,
  });
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: `${envApi}/getInfo`,
    method: "get",
  });
}

// 退出方法
export function logout() {
  return request({
    url: `${envApi}/logout`,
    method: "post",
  });
}
